import PropTypes from 'prop-types';
import React from 'react';
import * as Sentry from '@sentry/react';

import {
    ATTRIBUTION_MODE_NONE,
    USER_RELATIONSHIP_ATTRIBUTION_NONE,
} from '../../../../contexts/AbstractContext';

import {
    Consumer as CommunityContextConsumer,
    Provider as CommunityContextProvider,
} from '../../../../contexts/CommunityContext';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';

import UserListItem from '../UserListItem';
import './SearchResults.scss';

export class SearchResults extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            displayConnBtns: false,
            userResults: this.props.results.user.results,
        };
    }

    async componentDidMount() {
        const { defaultIds, fetchUserRelations } = this.props;

        try {
            if (defaultIds) {
                const result = await fetchUserRelations(defaultIds);
                if (!result.data?.data) return null;

                (result.data.data || []).forEach((user) => {
                    this.setState((state) => {
                        // TODO: this all doesn't seem to actually do anything... can it be removed?
                        // TODO: It's essentially cloning the data and reapplying it to state. Why?

                        const updateUserResults = [...state.userResults];

                        const [updatedUser] = updateUserResults.filter(
                            (uUser) => uUser.userId === user.userId
                        );

                        if (updatedUser) updatedUser.relation = user.relation;

                        return {
                            displayConnBtns: true,
                            userResults: updateUserResults,
                        };
                    });
                });
            }
        } catch (e) {
            Sentry.captureException(e);
            return false;
        }
    }

    setClickHandlers = (connStatus, user) => {
        switch (connStatus) {
            case 'connected': {
                return {};
            }
            default: {
                return {
                    handleConnect: () =>
                        this.props.requestConnection(user.userId),
                    handleFollow: () => this.props.followUser(user.userId),
                };
            }
        }
    };

    setButtonsToRender = (connStatus, pageContext) => {
        let output;
        switch (connStatus) {
            case 'connected': {
                output = ['REMOVE', 'MESSAGE'];
                break;
            }
            default: {
                output = ['FOLLOW', 'CONNECT'];
            }
        }

        if (pageContext.groups.isGroupAdmin()) {
            output[0] = 'INVITE_TO_GROUP';
        }

        return output;
    };

    render() {
        const {
            renderSeeAllButton: RenderSeeAllButton,
            url,
            btnText,
        } = this.props;

        return (
            <PageConsumer>
                {(pageContext) => (
                    <div className="component-Users-UserListItem-SearchResults">
                        <div className="container-list">
                            {this.state.userResults.map((user) => {
                                const {
                                    pageProps: { session },
                                } = pageContext;
                                const connStatus =
                                    user.relation.connectionStatus;
                                const followStatus = user.relation.isFollowing;
                                const isSameUser = session.id === user.userId;

                                if (isSameUser)
                                    return (
                                        <UserListItem
                                            key={user.userId}
                                            user={user}
                                            onClickHandlers={this.setClickHandlers(
                                                connStatus,
                                                user
                                            )}
                                            buttonsToRender={null}
                                            displayConnBtns={false}
                                            connectionStatus={connStatus}
                                            followStatus={followStatus}
                                            metricLocation="search-results"
                                        />
                                    );

                                return (
                                    <UserListItem
                                        key={user.userId}
                                        user={user}
                                        onClickHandlers={this.setClickHandlers(
                                            connStatus,
                                            user
                                        )}
                                        buttonsToRender={this.setButtonsToRender(
                                            connStatus,
                                            pageContext
                                        )}
                                        displayConnBtns={
                                            this.state.displayConnBtns
                                        }
                                        connectionStatus={connStatus}
                                        followStatus={followStatus}
                                        metricLocation="search-results"
                                    />
                                );
                            })}
                        </div>
                        <div className="container-btn">
                            <RenderSeeAllButton
                                type="user"
                                url={url}
                                text={btnText}
                            />
                        </div>
                    </div>
                )}
            </PageConsumer>
        );
    }
}

/* eslint-disable react/forbid-prop-types */
SearchResults.propTypes = {
    results: PropTypes.object, // TODO: update  with actual shapes and required statuses
    defaultIds: PropTypes.array, // TODO: update  with actual shapes and required statuses
    fetchUserRelations: PropTypes.func,
    followUser: PropTypes.func,
    requestConnection: PropTypes.func,
    renderSeeAllButton: PropTypes.func,
    btnText: PropTypes.string,
    url: PropTypes.string,
};
/* eslint-enable react/forbid-prop-types */

SearchResults.defaultProps = {
    results: {},
    defaultIds: [],
    fetchUserRelations: () => null,
    followUser: () => null,
    requestConnection: () => null,
    renderSeeAllButton: () => null,
    btnText: null,
    url: null,
};

export default (props) => {
    // eslint-disable-line
    return (
        <CommunityContextProvider
            content={[]}
            attributionMode={ATTRIBUTION_MODE_NONE}
            userRelationshipMode={USER_RELATIONSHIP_ATTRIBUTION_NONE}
        >
            <CommunityContextConsumer>
                {({
                    requestConnection,
                    followUser,
                    fetchUserRelations,
                    userRelations,
                }) => {
                    return (
                        <SearchResults
                            {...props}
                            requestConnection={requestConnection}
                            followUser={followUser}
                            fetchUserRelations={fetchUserRelations}
                            userRelations={userRelations}
                        />
                    );
                }}
            </CommunityContextConsumer>
        </CommunityContextProvider>
    );
};
